import isNil from 'lodash-es/isNil';

const utils = {
  buildBlockStyles: (
    params,
    globalScale,
    applyScaleFix = false,
    calcDimensions = false,
  ) => {
    // scale multiplier help to keep UI of the block always at the scale 1

    const scaleMultiplier = applyScaleFix ? globalScale : 1;
    const scaleX = isNil(params.scaleX) ? 1 : params.scaleX;
    const scaleY = isNil(params.scaleY) ? 1 : params.scaleY;
    // calcDimensions is to compute the displayed width & height based on fabric data
    // and use a CSS transfrom scale of 1
    // ie: sketchfab gets its dimensions in fabric only based on scaleXY. We MUST do it otherwise
    // the block could be deformed in the viewer.
    const width =
      calcDimensions || applyScaleFix ? params.width * scaleX : params.width;
    const height =
      calcDimensions || applyScaleFix ? params.height * scaleY : params.height;
    const angle = params.angle || 0;

    let translateX = 0;
    let translateY = 0;
    // position styles
    const positionStyles = {};
    if (params.originX === 'center') {
      translateX = -50;
    } else if (params.originX === 'right') {
      translateX = -100;
    }
    if (params.originY === 'center') {
      translateY = -50;
    } else if (params.originY === 'bottom') {
      translateY = -100;
    }
    // dimension styles
    const dimensionStyles = {
      width: applyScaleFix ? Math.round(width * scaleMultiplier) : width,
      height: applyScaleFix ? Math.round(height * scaleMultiplier) : height,
      left: params.left,
      top: params.top,
    };
    // transform styles
    const transformStyles = {
      transform:
        applyScaleFix || calcDimensions
          ? `translate(${translateX}%, ${translateY}%) rotate(${angle}deg)  scale(${1 /
              scaleMultiplier})`
          : `translate(${translateX}%, ${translateY}%) rotate(${angle}deg) scale(${scaleX}, ${scaleY})`,
      transformOrigin: `${params.originX || 'left'} ${params.originY || 'top'}`,
    };
    if (params.type === 'ludusImage' || params.type === 'ludusRect') {
      return {
        position: 'absolute',
        // pointerEvents: params.ludus.hyperlink ? 'auto' : 'none',
        filter: params.shadow
          ? `drop-shadow(${params.shadow.offsetX}px ${
              params.shadow.offsetY
            }px ${params.shadow.blur * 0.35}px ${params.shadow.color})`
          : 'none',
        height: 0,
        width: 0,
      };
    }
    return {
      display: 'block',
      position: 'absolute',
      ...positionStyles,
      ...dimensionStyles,
      ...transformStyles,
    };
  },

  getXPositionMediaButton: (h, R, y) =>
    h === 'left'
      ? R + Math.sqrt(R ** 2 - (R - y) ** 2)
      : R - Math.sqrt(R ** 2 - (R - y) ** 2),

  stopPropagation(e) {
    e.stopPropagation();
  },

  preventDefault(e) {
    e.preventDefault();
  },
};

export default utils;
